import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  BarOptions,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

interface GraficoBarra {
  titulo: string,
  keyX: string,
  value: string
  keyForExctratTitles: string
  dados: Array<any>,
  color?: string
}

export default function GraficoBarra(props: GraficoBarra) {

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    categoryPercentage: 1,
    barPercentage: .5,
    maxBarThickness: 120,
    elements: {
      bar: {
        borderWidth: 2,
        color: '#eee',
      },
    },
    scales: {
      y: {
        grid: {
          drawTicks: false,
          drawOnChartArea: true,
          display: true,
          margin: 5,
          beginAtZero: false
        },
        ticks: {
          display: false,
          color: '#eeeeee',
          count: 5,
        },
        border: {
          dash: [6, 6],
          display: false
        },
      },
      x: {
        grid: {
          drawTicks: false,
          display: false
        },
        ticks: {
          color: '#eeeeee'
        },

      }
    },
    plugins: {
      legend: {
        position: 'top' as const,
        labels: {
          color: '#eeeeee',
          title: {
            color: '#eeeeee'
          },
        },
        height: 60,
        background: '#ccc'
      },
      title: {
        display: true,
        text: props.titulo,
        color: '#eeeeee',
      },
      datalabels: {
        align: function (context: Context) {
          return 'end';
        },
        anchor: function (context: Context) {
          return 'end';
        },
        color: '#d3d3d3',
        padding: -5
      },
    }
  };

  const labels = props.dados?.map(e => e[props?.keyForExctratTitles]);
  const dads = props.dados.map(
    (e, i) => {
      return {
        label: e[props?.keyForExctratTitles],
        data: [e?.[props?.keyX]],
        backgroundColor: `rgba(${Math.ceil((Math.random() * i + (70 - Math.random() * 100)))}, ${Math.ceil((Math.random() * i + (162 - Math.random() * 120)))}, ${Math.ceil((Math.random() * i + (200 - Math.random() * 140)))})`,
      }
    })

  const data = {
    labels: [props?.value],
    datasets: dads,
  };

  return <section style={{ height: '100%', width: '100%', display: 'flex', padding: '0 8px', alignContent: 'center', justifyContent: 'center' }}>
    <Bar
      width={400}
      height={500}
      options={options}
      data={data}
    />
  </section>
}
